
/* START_TEMPLATE */
define('hbs!app/views/templates/redirect3DS',['hbs','Handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var helper;

  return "    <input type=\"hidden\" name=\""
    + this.escapeExpression(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"name","hash":{},"data":data}) : helper)))
    + "\" value=\""
    + this.escapeExpression(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"value","hash":{},"data":data}) : helper)))
    + "\" />\r\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1, helper, options, buffer = 
  "<form id=\"redirect3DSForm\" action=\""
    + this.escapeExpression(((helper = (helper = helpers.forwardURL || (depth0 != null ? depth0.forwardURL : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0,{"name":"forwardURL","hash":{},"data":data}) : helper)))
    + "\" method=\"POST\">\r\n";
  stack1 = ((helper = (helper = helpers.fields || (depth0 != null ? depth0.fields : depth0)) != null ? helper : helpers.helperMissing),(options={"name":"fields","hash":{},"fn":this.program(1, data, 0),"inverse":this.noop,"data":data}),(typeof helper === "function" ? helper.call(depth0,options) : helper));
  if (!helpers.fields) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "    <input type=\"submit\" style=\"visibility:hidden\"/>\r\n</form>\r\n";
},"useData":true});
Handlebars.registerPartial('app/views/templates/redirect3DS', t);
return t;
});
/* END_TEMPLATE */
;
